import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, IsNotEmpty, IsOptional, Matches, MaxLength } from "class-validator";

export class RmPriceListDTO{
    @ApiProperty()
    @IsNotEmpty({message:"rm price list id should not be empty"})
    @IsAlphanumeric()
   rmPriceListId:number;

   @ApiProperty()
    @IsNotEmpty({message:"date should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    date:Date;

    @ApiProperty()
    @IsNotEmpty({message:"count range should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    minCount:number;

    @ApiProperty()
    @IsNotEmpty({message:"count range should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    maxCount:number;

    @ApiProperty()
    @IsNotEmpty({message:"price should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    price:number;

    @ApiProperty()
    isActive:boolean;

   
    createdAt:Date;

    @ApiProperty()
   @IsOptional()
   @MaxLength(50,{message:"Created User allows maximum 50 characters"}) 
   @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })  
    createdUser: string | null;
  
  
   
    updatedAt: Date;

    @ApiProperty()
  @IsOptional()
  @MaxLength(50, { message: "Updated User allows maximum 50 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
    updatedUser: string | null;

  
    @ApiProperty()
    versionFlag : number;
  

}